import React, { useState, useEffect, useRef } from 'react';


const getNewItem = () => ({ id: `temp-${Date.now()}-${Math.random()}`, name: '', amount: '', unit: '' });

const AddAdditionalItemGroupModal = ({ isOpen, onClose, onSave, editingGroup }) => {
  const [title, setTitle] = useState('');
  const [items, setItems] = useState([getNewItem()]);
  const [error, setError] = useState('');
  const titleInputRef = useRef(null);
  const modalRef = useRef(null);
  const itemsRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      if (editingGroup) {
        setTitle(editingGroup.title);
        setItems([...editingGroup.items, getNewItem()]);
      } else {
        setTitle('');
        setItems([getNewItem()]);
      }
      setError('');
      setTimeout(() => titleInputRef.current?.focus(), 0);
    }
  }, [isOpen, editingGroup]);

  if (!isOpen) return null;

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;
    setItems(updatedItems);
  };

  const handleAddItemField = () => {
    setItems([...items, getNewItem()]);
    setTimeout(() => {
      itemsRef.current?.lastElementChild?.querySelector('input')?.focus();
    }, 0);
  };

  const handleRemoveItem = (index) => {
    const updatedItems = [...items];
    updatedItems.splice(index, 1);
    setItems(updatedItems);
  };

  const handleItemKeyDown = (e, index) => {
    if (e.key === 'Enter') {
      if (items[index].name.trim() !== '' && index === items.length - 1) {
        e.preventDefault();
        handleAddItemField();
      }
    }
  };

  const handleSave = async (andAnother = false) => {
    if (!title) {
      setError('Item group title cannot be empty');
      return;
    }
    const formattedItems = items.filter(item => item.name.trim() !== '');
    const response = await onSave({ ...editingGroup, title, items: formattedItems }, andAnother);
    if (response && response.error) {
      setError(response.error);
    } else {
      if (andAnother) {
        setTitle('');
        setItems([getNewItem()]);
        setError('');
        titleInputRef.current.focus();
      } else {
        onClose();
      }
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" ref={modalRef}>
        <div className="modal-header">
          <h2><i className="material-icons" style={{ marginRight: '5px', verticalAlign: 'top' }}>add_shopping_cart</i>{editingGroup ? 'Edit Item Group' : 'Add Item Group'}</h2>
          <button onClick={onClose} className="icon-button close-button" title="Close"><i className="material-icons">close</i></button>
        </div>
        <div className="modal-body">
          {error && <p className="error-message">{error}</p>}
          <div className="search-input-container">
            <input
              ref={titleInputRef}
              type="text"
              placeholder="Item Group Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSave(!editingGroup)}
            />
            {title && <button title="Clear title" onClick={() => { setTitle(''); titleInputRef.current.focus(); }} className="clear-input-button"><i className="material-icons">close</i></button>}
          </div>
          <div className="ingredients-header">
            <h3>Items</h3>
            <button title="Add item field" onClick={handleAddItemField} className="plus-button"><i className="material-icons">add</i></button>
          </div>
          <div ref={itemsRef}>
            {items.map((item, index) => (
              <div key={item.id} className="ingredient-input" style={{ display: 'flex', gap: '1rem' }}>
                <input
                  type="text"
                  placeholder="Name"
                  value={item.name}
                  onChange={(e) => handleItemChange(index, 'name', e.target.value)}
                  onKeyDown={(e) => handleItemKeyDown(e, index)}
                />
                <input
                  type="number"
                  placeholder="Amount"
                  value={item.amount}
                  onChange={(e) => handleItemChange(index, 'amount', e.target.value)}
                  onKeyDown={(e) => handleItemKeyDown(e, index)}
                />
                <select
                  value={item.unit}
                  onChange={(e) => handleItemChange(index, 'unit', e.target.value)}
                  onKeyDown={(e) => handleItemKeyDown(e, index)}
                >
                  <option value=""></option>
                  <option value="tsp">tsp</option>
                  <option value="tbsp">tbsp</option>
                  <option value="cup">cup</option>
                  <option value="oz">oz</option>
                  <option value="lb">lb</option>
                  <option value="g">g</option>
                  <option value="kg">kg</option>
                  <option value="ml">ml</option>
                </select>
                <button title="Remove item" onClick={() => handleRemoveItem(index)} className="icon-button delete-button"><i className="material-icons">delete</i></button>
              </div>
            ))}
          </div>
        </div>
        <div className="modal-footer">
          {!editingGroup && <button title="Save and add another" onClick={() => handleSave(true)}>Save and another</button>}
          <button title="Save and close" onClick={() => handleSave(false)}>Save and close</button>
          <button title="Cancel" onClick={onClose} className="cancel-button">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default AddAdditionalItemGroupModal;